import { render } from "./RelatorioReservas.vue?vue&type=template&id=262e89ad&scoped=true"
import script from "./RelatorioReservas.vue?vue&type=script&lang=js"
export * from "./RelatorioReservas.vue?vue&type=script&lang=js"

import "./RelatorioReservas.vue?vue&type=style&index=0&id=262e89ad&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262e89ad"]])

export default __exports__